import {AxiosResponse} from "axios";
import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";
import {NewOrUpdateParkingPriceListsModel, PriceListFilter, PriceListModel} from "../models/priceList";
import {PageableModel} from "../../common/models/table";
import {HttpErrorModel} from "../../common/models/httpError";

export class PriceListService {
    private static baseUrl = apiUrls.priceList.priceList;

    public static async getAll(filters: PriceListFilter): Promise<AxiosResponse<PageableModel<PriceListModel>>> {
        const sortingAndFilteringParams = {
            filterCondition: filters && filters.startDate && `${filters.startDate}`
        };

        return await http.get<PageableModel<PriceListModel>>(`${Api.addSortingAndFilteringParams(Api.getUrl(this.baseUrl), sortingAndFilteringParams)}`);
    }

    public static async getPrice(id: string): Promise<AxiosResponse<PriceListModel>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${id}`);
    }

    public static async addPrice(data: NewOrUpdateParkingPriceListsModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(Api.getUrl(this.baseUrl), data);
    }

    public static async modifyPrice(data: NewOrUpdateParkingPriceListsModel, id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/${id}`, data);
    }
}
